import { makeStyles } from 'tss-react/mui'
import { StyleProps } from './types'

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  // eslint-disable-next-line tss-unused-classes/unused-classes
  table: {
    borderCollapse: 'separate',
    paddingBottom: theme.spacing(2),
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  spacer: {
    height: theme.spacing(2),
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  customTableRow: {
    cursor: props.onSelect ? 'pointer' : 'default',
    backgroundColor: props.coloredColumn ? theme.palette.background.paper2 : 'white',
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  highlightedRow: {
    backgroundColor: theme.palette.background.paper2,
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  lastRow: {
    '& > *': {
      borderBottom: 'none',
    },
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  headerRow: {
    '& > *': {
      borderBottomWidth: 2,
    },
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  pagination: {
    marginBottom: theme.spacing(2),
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  tableCell: {
    color: theme.palette.text.primary,
    ...(props.allowOtherCellColors
      ? {}
      : {
          '& > *': {
            color: theme.palette.text.primary,
          },
        }),
  },
}))

export default useStyles
